/**
 * --------------------------------------------------------------------------
 * Frontend template: header-scroll-up
 * @author Patrick Schlesinger ps@contexlabs.com
 * --------------------------------------------------------------------------
 */

import debug from "debug";
import config from '../../config/config';

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const log = debug(`${config.debugNamespace}:CLHeaderScrollUp`);

const CLASS_HEADER_WRAPPER = 'page-header';

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class CLHeaderScrollUp {
    /**
     * @param element
     */
    constructor(element) {
        log('Init');

        if (!element) {
            log('missing element');
            return;
        }

        /**
         * @type {Element}
         * @private
         */
        this.header = element;

        this.doc = document.documentElement;

        this.prevScroll = window.scrollY || this.doc.scrollTop;
        this.curScroll = null;
        this.direction = 0;
        this.prevDirection = 0;

        window.addEventListener('scroll', () => {
            this.checkScroll();
        });
    }

    checkScroll() {
        /*
        ** Find the direction of scroll
        ** 0 - initial, 1 - up, 2 - down
        */

        this.curScroll = window.scrollY || this.doc.scrollTop;
        if (this.curScroll > this.prevScroll) {
            // scrolled up
            this.direction = 2;
        } else if (this.curScroll < this.prevScroll) {
            // scrolled down
            this.direction = 1;
        }

        if (this.direction !== this.prevDirection) {
            this.toggleHeader(this.direction, this.curScroll);
        }

        this.prevScroll = this.curScroll;
    }

    toggleHeader(direction, curScroll) {
        if (direction === 2 && curScroll > 52) {
            // replace 52 with the height of your header in px

            this.header.classList.add('hide');
            this.prevDirection = direction;
        } else if (direction === 1) {
            this.header.classList.remove('hide');
            this.prevDirection = direction;
        }
    }
}

/**
 * ------------------------------------------------------------------------
 * Init
 * ------------------------------------------------------------------------
 */

[...document.getElementsByClassName(CLASS_HEADER_WRAPPER)].forEach(
    /**
     * @param ele
     * @returns {CLCountUP}
     */
    (ele) => new CLHeaderScrollUp(ele),
);
